import type {
  CustomColorPalette,
  ColorPalette,
} from '../../../core/types/color-palette.js';
import { getColorPalette } from '../../../core/utils/get-color-palette.js';
import { DEFAULT_COLOR_PALETTE } from '../default.js';

const parseColorPalette = (
  colorPalette?: ColorPalette | CustomColorPalette,
) => {
  if (!colorPalette) {
    return DEFAULT_COLOR_PALETTE;
  }

  if (typeof colorPalette === 'string' || Array.isArray(colorPalette)) {
    return colorPalette;
  }

  return Object.values(colorPalette);
};

export const applySegmentColor = (
  segmentName: string,
  index: number,
  colorPalette?: ColorPalette | CustomColorPalette,
  color?: string,
): string => {
  if (color) {
    return color;
  }

  const palette = parseColorPalette(colorPalette);

  const segmentColor = getColorPalette(segmentName, index, palette);

  return segmentColor.Default;
};
